import { render, staticRenderFns } from "./PopupNotification.vue?vue&type=template&id=b2180680&"
import script from "./PopupNotification.vue?vue&type=script&lang=ts&"
export * from "./PopupNotification.vue?vue&type=script&lang=ts&"
import style0 from "./PopupNotification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
